<div class="row ccorbit-form-group">
        <div class="col-2 d-inline">
            <label class="fw-semibold gray-color">Mercados</label>
        </div>
        <div class="col-4 d-inline">
            <select class="form-select form-select-sm listas" aria-label=".form-select-sm example"
                (change)="buscarCompania()" [(ngModel)]="selectedValue">
                <option [ngValue]="mercado.idmercado" *ngFor="let mercado of listaMercado">
                    {{mercado.iso}}</option>
            </select>
        </div>
        <div class="col-2 d-inline">
            <label class="fw-semibold gray-color">Nombre Lista</label>
        </div>
        <div class="col-4 d-inline">
            <input type="text" class="form-control form-control-sm listas"
                   placeholder="Nombre de la lista"
                   [(ngModel)]="nombreLista"
                   [disabled]="!selectedValue">
        </div>
    </div>

    <div class="row ccorbit-form-group mt-2">
        <div class="col-12 text-end">
            <button  mat-flat-button class="ccorbit" (click)="EditarLista()">
                <mat-icon class="me-1">save</mat-icon>
                Guardar
            </button>
        </div>
    </div>


<div class="row mt-2">
    <cdk-virtual-scroll-viewport #eliminarComp id="eliminarComp" item [appendOnly]="false" [tvsItemSize]="24"
        [headerHeight]="34" class="wrapper mat-elevation-z2 tableStyle">
        <table cdk-table [dataSource]="companias" class="table-striped tableStyle">

            <!-- Position Column -->
            <ng-container cdkColumnDef="n">
                <th cdk-header-cell *cdkHeaderCellDef class="first-column sticky-header"> #.
                </th>
                <td cdk-cell *cdkCellDef="let element" class="first-column"> {{element.n}} </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container cdkColumnDef="iso">
                <th cdk-header-cell *cdkHeaderCellDef class="sticky-header first-column"> Compañia </th>
                <td cdk-cell *cdkCellDef="let element" class="first-column"> <a class="activo-link" [href]="urlMercadoActivo(element)" target="_blank">{{element.iso}} <mat-icon>open_in_new</mat-icon></a> </td>
            </ng-container>

            <!-- Weight Column -->
            <ng-container cdkColumnDef="descripcion">
                <th cdk-header-cell *cdkHeaderCellDef class="sticky-header"> Descripcion </th>
                <td cdk-cell *cdkCellDef="let element"> {{element.descripcion}} </td>
            </ng-container>

            <ng-container cdkColumnDef="tipo">
                <th cdk-header-cell *cdkHeaderCellDef class="sticky-header first-column"> Tipo
                </th>
                <td cdk-cell *cdkCellDef="let element" class="first-column"> {{element.tipo}}
                </td>
            </ng-container>

            <ng-container cdkColumnDef="mercado">
                <th cdk-header-cell *cdkHeaderCellDef class="sticky-header first-column">
                    Mercado </th>
                <td cdk-cell *cdkCellDef="let element" class="first-column"> {{element.mercado}}
                </td>
            </ng-container>
            <ng-container cdkColumnDef="acciones">
                <th cdk-header-cell *cdkHeaderCellDef class="sticky-header"> Acciones </th>
                <td cdk-cell *cdkCellDef="let element">
                    <button class="btn btn-danger btn-sm d-flex align-items-center justify-content-center"
                            (click)="eliminar(element)">
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr cdk-header-row *cdkHeaderRowDef="displayedColumns; sticky: true" class="sticky-header"></tr>
            <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;"></tr>
        </table>

    </cdk-virtual-scroll-viewport>

</div>

